module.exports = __webpack_public_path__ + "static/tiffany-9dcdc051acfe6fe128d19137303eed13.jpg";